import React from 'react';
import Fade from '@material-ui/core/Fade';
import Base, { CopyContainer, FADE_TIMEOUT, H2, Icon, ImgContainer, P, Root } from '../Base';

class Farewell extends Base {
  static isVisible = () => true;

  icon = '/images/insurance_tutorial/11_end.svg';

  render = () => {
    return (
      <Fade in timeout={FADE_TIMEOUT}>
        <Root>
          <ImgContainer>
            <Icon src={this.icon} />
          </ImgContainer>

          <CopyContainer>
            <H2>You've got this</H2>
            <P>Solv lets you track your benefits and watch your spending throughout the year.</P>

            <P>Next up, check your progress towards your deductible and preventive perks.</P>
          </CopyContainer>
        </Root>
      </Fade>
    );
  };
}

export default Farewell;
